var _tspan, _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.26458)",
    fill: "#000000",
    fontSize: "29.333px",
    style: {
      shapeInside: "url(#rect113)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.11 0 0 2.1227 9.3799 25.073)",
    x: 29.581059,
    y: 57.747612,
    fill: "#2aad41",
    fontSize: "25.4px",
    strokeWidth: 0.26458,
    style: {
      inlineSize: 121.779,
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 29.581059,
    y: 57.747612
  }, "avar"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.9711,
    y: 87.426,
    width: 5.5572,
    height: 61.021,
    fill: "#2aad41",
    strokeWidth: 0.28352
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.554,
    y: 87.217,
    width: 5.0355,
    height: 61.287,
    strokeWidth: 0.27047
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.028 148.61 194.27 1.1411",
    fill: "#f00",
    strokeWidth: 0.26458
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81.138 160.83 119.85 37.06",
    fill: "#2adb17",
    strokeWidth: 1.6202
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.358 87.213 36.966 37.121",
    strokeWidth: 3.665
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.465 90.161s16.218-1.226 28.032 14.107c10.436 13.543 13.015 28.11 13.015 28.11",
    fill: "none",
    stroke: "#2aad41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.365,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.24 145.51s-19.278 1.8608-31.616-12.893c-10.394-12.429-10.883-29.283-10.883-29.283",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.365,
    style: {
      paintOrder: "markers fill stroke"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b9ae72ec0c8cd855ac0b077849d4c2c.svg";
export { ForwardRef as ReactComponent };